import React from 'react';

const WidgetUrl = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icons MASTER">
            <path id="Send" d="M19.857 35.9989L5.57129 4.57031L36.9999 18.856L24.6189 23.6179L19.857 35.9989Z"
                  stroke={couleur} strokeWidth="4" strokeLinejoin="round"/>
        </g>
    </svg>
);

export default WidgetUrl;
